// extracted by mini-css-extract-plugin
export default {"container":"styles_container__s9Tw9","title":"styles_title__uYFf+","content":"styles_content__ZK3HU","actionButton":"styles_actionButton__tMGmn"};